export const environment = {
  production: false,
  apiUrl: 'https://api.dev.karibooking.com',
  publicBaseUrl: 'https://api.dev.karibooking.com',
  storageUrl: 'https://api.dev.karibooking.com/storage/',
  /** Hosts allowed for payment gateway redirects (exact or subdomain). */
  paymentRedirectHosts: ['flexpay.cd', 'flexpay.test'] as const,
};
